;(() => {
  new Swiper('nav.blogs-index-nav .swiper', {
    autoHeight: true,
    grabCursor: true,
    slidesPerView: 'auto',
    freeMode: true
  })

  new Swiper('section.links-pills .swiper', {
    autoHeight: true,
    slidesPerView: 'auto',
    grabCursor: true,
    freeMode: true,
    spaceBetween: 15
  })

  document
    .querySelectorAll('section.featured-products .swiper')
    .forEach((section) => {
      new Swiper(section, {
        autoHeight: true,
        slidesPerView: 1.2,
        freeMode: true,
        spaceBetween: 10,
        grabCursor: true,
        breakpoints: {
          400: {
            spaceBetween: 10,
            slidesPerView: 2.2
          },
          800: {
            spaceBetween: 15,
            slidesPerView: 3.2
          },
          1100: {
            spaceBetween: 30,
            slidesPerView: 4
          }
        }
      })
    })

  document.querySelectorAll('section.reviews .swiper').forEach((section) => {
    new Swiper(section, {
      autoHeight: true,
      slidesPerView: 1,
      freeMode: false,
      spaceBetween: 30,
      grabCursor: true,
      pagination: {
        el: document.querySelector('section.reviews .swiper-pagination')
      },
      breakpoints: {
        800: {
          freeMode: true,
          spaceBetween: 15,
          slidesPerView: 2.5
        },
        1100: {
          freeMode: true,
          spaceBetween: 30,
          slidesPerView: 3
        }
      }
    })
  })

  document
    .querySelectorAll('section.featured-collection .swiper')
    .forEach((section) => {
      new Swiper(section, {
        slidesPerView: 1,
        spaceBetween: 15,
        grabCursor: true,
        scrollbar: {
          el: section.querySelector('.swiper-scrollbar.featured-collection')
        },
        on: {
          init: function (instance) {
            setTimeout(() => {
              instance.update()
            }, 2000)
          }
        }
      })
    })

  window.initCartRecommendationsSwipers = () => {
    new Swiper('.cart-product-recommendations-swiper.swiper', {
      autoHeight: true,
      grabCursor: true,
      navigation: {
        nextEl: 'button.swiper-control.cart-product-recommendations-next',
        prevEl: 'button.swiper-control.cart-product-recommendations-prev'
      },
      breakpoints: {
        1200: {
          slidesPerView: 3
        },
        1050: {
          slidesPerView: 2
        }
      },
      spaceBetween: 15,
      slidesPerView: 1
    })

    new Swiper('.cart-product-recommendations-swiper-mobile.swiper', {
      autoHeight: true,
      grabCursor: true,
      navigation: {
        nextEl: '.cart-products-next',
        prevEl: '.cart-products-prev'
      },
      spaceBetween: 0,
      slidesPerView: 1
    })
  }

  new Swiper('section.banner .swiper.terms-mobile', {
    autoHeight: true,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    speed: 500,
    autoplay: { delay: 3000 },
    slidesPerView: 1,
    a11y: {
      slideRole: 'link'
    }
  })

  new Swiper('section.sub-collections .swiper', {
    slidesPerView: 'auto',
    grabCursor: true,
    freeMode: true,
    spaceBetween: 0
  })
})()

function getInitialSlide(container) {
  const selectedVariantId = container.getAttribute('data-initial-variant-id')

  const imageForVariant = container.querySelector(
    `figure.product-carousel .swiper-slide[data-variant-id="${selectedVariantId}"]`
  )

  if (imageForVariant) {
    const initialIndex = [...imageForVariant.parentNode.children].indexOf(
      imageForVariant
    )

    return initialIndex
  }
}

function initProductCarousel(containerElement, product) {
  const thumbs = new Swiper(
    containerElement?.querySelector('.swiper-product-thumbs'),
    { slidesPerView: 'auto', freeMode: true }
  )

  const product_carousel = new Swiper(
    containerElement?.querySelector('.swiper-product'),
    {
      autoHeight: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      initialSlide: getInitialSlide(containerElement),
      spaceBetween: 10,
      slidesPerView: 1,
      on: {
        slideChange: function () {
          //select relevant combination of options in the variant picker
          //it's important the click event is triggered on the input element here, and not the label
          //triggering click on the label will cause the page to scroll to the label as it gets focus on click
          const slideElement = this.slides[this.activeIndex]
          const variantId = Number(slideElement.getAttribute('data-variant-id'))

          if (slideElement.classList.contains('variant-primary-image')) {
            const relevantVariant = product.variants.find(
              (variant) => variant.id === variantId
            )

            relevantVariant?.options.forEach((option, index) => {
              const radioButton = containerElement.querySelector(
                `label[data-option-${index + 1}="${handleize(option)}"] input`
              )

              const selectElement = containerElement.querySelector(
                `label.select select[name="option${index + 1}"]`
              )

              if (radioButton) {
                radioButton.click()
              } else if (selectElement) {
                selectElement.value = handleize(option)
                selectElement.dispatchEvent(
                  new Event('change', { bubbles: true })
                )
              }
            })
          }
        },
        init: function (swiper) {
          if (swiper.slides.length <= 1) {
            containerElement
              .querySelectorAll('.swiper-navigation')
              .forEach((element) => (element.hidden = true))
          }
        }
      },
      breakpoints: {
        800: {
          slidesPerView: 1
        }
      },
      thumbs: {
        swiper: thumbs
      }
    }
  )

  return product_carousel
}
